import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	ConnectionsModalComponent,
	ConnectionsListComponent,
	ConnectionsAddEditComponent,
	ConnectionsQrCodeComponent
} from './components';
import { ExternalTransferModule } from '@api/external-transfer';
import { HttpModule } from '@api/http';
import { ConnectionsModalState, ConnectionsManagerService } from './services';
import { SmartComponentsModule } from '@pages/smart-components';

@NgModule({
	providers: [ConnectionsModalState, ConnectionsManagerService],
	declarations: [
		ConnectionsModalComponent,
		ConnectionsListComponent,
		ConnectionsAddEditComponent,
		ConnectionsQrCodeComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		TranslateModule,
		SmartComponentsModule,
		IonicModule,
		ReactiveFormsModule,
		FormsModule,
		ExternalTransferModule,
		HttpModule
	]
})
export class ConnectionsModule {}
